import axios from 'axios';

import formatError from './format-error';

let csrfToken: string | null = null;
let refreshPromise: Promise<string> | null = null;
let consecutiveFailures = 0;
const MAX_CONSECUTIVE_FAILURES = 5;

export function getCsrfToken(): string | null {
  return csrfToken;
}

export async function refreshCSRFToken(): Promise<void> {
  if (consecutiveFailures >= MAX_CONSECUTIVE_FAILURES) {
    throw new Error('Too many CSRF refresh failures. Please refresh the page.');
  }

  if (refreshPromise) {
    try {
      await refreshPromise;
      return;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
    } catch (e) {
      // existing promise failed — fall through and try again
    }
  }

  refreshPromise = fetchCSRFToken();

  try {
    csrfToken = await refreshPromise;
    consecutiveFailures = 0;
  } finally {
    refreshPromise = null;
  }
}

async function fetchCSRFToken(): Promise<string> {
  try {
    const cleanAxios = axios.create({ withCredentials: true, timeout: 10000 });
    const response = await cleanAxios.get<{ csrfToken: string }>('/api/users/get-csrf-token');
    return response.data.csrfToken;
  } catch (error) {
    consecutiveFailures++;
    throw formatError(error);
  }
}
